import { createContext } from "react"
export const { Consumer, Provider } = createContext("store")



// WEBPACK FOOTER //
// ./src/lib/StoreContext.js